import { Pipe, PipeTransform } from '@angular/core';
import { filter } from 'lodash';
import { IReferenceData } from '../interfaces/form/reference-data.model';

@Pipe({
    name: 'filterEiDocumentTypes',
    standalone: false
})
export class FilterEiDocumentTypePipe implements PipeTransform {
  transform(data: IReferenceData[]): IReferenceData[] {
    return filter(data, (d: IReferenceData) => {
      return d.value === '1';
    });
  }
}
